export default function busPopup(data) {
	return `<div class='content-wrapper clearfix bus-vehicle'>
	<h3>Route ${data.route}</h3>
	<p>
		Vehicle number:
		${data.vehicle_id}
	</p>
	<p>
		Position last updated:
		${data.lastUpdated}
	</p>
	${data.bearing ? `
		<p>
			Heading:
			${data.bearing}
		</p>
	` : ''}
	${data.occupancy_status ? `
		<p>
			Occupancy status:
			${data.occupancy_status}
		</p>
	` : ''}
</div>`;
}
